/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SupportHours } from "~/models";

export function displayServiceHours(value: string) {
  switch (value) {
    case SupportHours.NOT_APPLICABLE:
      return "Not Applicable";
    case SupportHours.H8D5:
      return "8x5";
    case SupportHours.H8D7:
      return "8x7";
    case SupportHours.H24D5:
      return "24x5";
    case SupportHours.H24D7:
      return "24x7";
    default:
      return "-";
  }
}
